module.exports = __webpack_public_path__ + "static/media/klima.0382ebdd.m4a";